import React from 'react';
import { QuestionnaireContext } from '../Contexts';
import { isQuestionnaire } from '../../unsw-fhir/Questionnaire/typeGuards';
import { QuestionnaireItemComponent } from '../../unsw-fhir/Questionnaire';

type ViewProps = {
  handleSubmit: (
    event?: React.SyntheticEvent<HTMLFormElement>,
  ) => Promise<object | undefined> | undefined;
  Component: React.ComponentType<QuestionnaireItemComponent>;
};
const View = ({ handleSubmit, Component }: ViewProps) => (
  <form onSubmit={handleSubmit}>
    <QuestionnaireContext.Consumer>
      {({ itemView }) =>
        itemView ? (
          isQuestionnaire(itemView) ? (
            itemView.item.map(i => <Component key={i.linkId} {...i} />)
          ) : (
            <Component {...itemView} />
          )
        ) : null
      }
    </QuestionnaireContext.Consumer>
  </form>
);

export default View;
